import { ApiError } from './'

export class TokenExpiredError extends ApiError {
  constructor(message = 'Your Token Has Expired') {
    super(message)
    Object.setPrototypeOf(this, TokenExpiredError.prototype)
    this.name = this.constructor.name
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/errors/token-expired-error.ts